import {useEffect, useState} from 'react';
import {Box, Grid, Typography} from '@mui/material';
import LoginForm from '../auth/LoginForm';
import '../../styles/components/landing-hero.css';

export default function LandingHero() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const titleWords = [
    'für interaktives Lernen',
    'für soziales Quizzen',
    'für digitale Bildung',
    'für gemeinsamen Spaß'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % titleWords.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [titleWords.length]);

  return (
    <div className="container-fixed">
      <Grid container spacing={8} alignItems="stretch" className="hero-grid">
        {/* Left Column - Content */}
        <Grid item xs={12} md={8} className="hero-grid-item left-column">
          <Box className="hero-grid-content">
            <Typography variant="h1" className="hero-title">
              <Box component="span">
                Die Plattform
              </Box>
              <Box component="span" className="hero-title-word">
                <Box className="hero-title-animated">
                  {titleWords[currentWordIndex]}
                </Box>
              </Box>
            </Typography>

            <Typography variant="h5" className="hero-description" sx={{ mb: 6 }}>
              Erstelle spannende Quiz-Runden, fordere deine Freunde heraus und lerne gemeinsam Neues!
            </Typography>

            {/* Stats Section */}
            <Grid container spacing={3}>
              {[
                { value: '1000+', label: 'Aktive Spieler' },
                { value: '500+', label: 'Quiz-Fragen' },
                { value: '4.8', label: 'Ø Bewertung' }
              ].map((stat, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Box className="hero-stat-card" style={{ animationDelay: `${0.2 * index}s` }}>
                    <Typography variant="h3" className="hero-stat-value">
                      {stat.value}
                    </Typography>
                    <Typography className="hero-stat-label">
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Right Column - Login Form */}
        <Grid item xs={12} md={4} className="hero-grid-item">
          <Box className="hero-login-container hero-grid-content">
            <Typography variant="h5" className="hero-login-heading">
              Jetzt gratis registrieren!
            </Typography>
            <LoginForm defaultToRegister={true} showRegisterFirst={true} />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
} 